module.exports = __webpack_public_path__ + "static/media/(H)_MG_5869_-_Cia_Termal_Beachewear_-_Moda_Feminina.e771b3ab.jpg";